export const PASSWORD_FETCH_EXISTING_INIT = 'PASSWORD_FETCH_EXISTING_INIT';
export const PASSWORD_FETCH_EXISTING_SUCCESS =
  'PASSWORD_FETCH_EXISTING_SUCCESS';
export const PASSWORD_FETCH_EXISTING_ERROR = 'PASSWORD_FETCH_EXISTING_ERROR';
